import { useState } from "react";
import type { FaqItem } from "@/mocks/faqs";

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="border border-background-200 rounded-lg overflow-hidden bg-background-50">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q} className="border-b border-background-200 last:border-b-0">
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="font-medium text-sm md:text-base text-foreground-950">{item.q}</span>
                <span className="w-6 h-6 shrink-0 flex items-center justify-center text-foreground-500">
                  <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true"></i>
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="px-4 md:px-5 pb-5 -mt-1">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}